import React from 'react';

// Component that displays mid-market price variations for different data points
const MMPVariationsTable = ({ midMarketPrice, olswapData, osmosisPoolData }) => {

  // Function to determine the text color based on price variation
  const getStyle = (currentPrice, midMarketPrice) => {
    const variation = (currentPrice / midMarketPrice - 1) * 100;
    return variation >= 0 ? 'text-green-500' : 'text-red-500';
  }

  // Function to return an upward or downward triangle icon based on price variation
  const getVariationIcon = (currentPrice, midMarketPrice) => {
    const variation = (currentPrice / midMarketPrice - 1) * 100;
    if (variation >= 0) {
      return <span className="text-green-500">&#9650;</span>;  // Unicode for upward triangle
    } else {
      return <span className="text-red-500">&#9660;</span>;  // Unicode for downward triangle
    }
  }

  return (
    <div className="max-w-md mx-auto my-8">
      <table className="w-full text-sm text-center text-gray-600">
        <thead>
          <tr className="text-xs uppercase bg-gray-50">
            <th className="py-2 px-4">Description</th>
            <th className="py-2 px-4">Price</th>
            <th className="py-2 px-4">Variation (%)</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td className="py-2 px-4">0Lswap MMP</td>
            <td className="py-2 px-4">${midMarketPrice.toFixed(6)}</td>
            <td className="py-2 px-4">-</td>
          </tr>
          <tr>
            <td className="py-2 px-4">0Lswap LTP</td>
            <td className="py-2 px-4">${olswapData.lastTransactionPrice.toFixed(6)}</td>
            <td className={`py-2 px-4 ${getStyle(olswapData.lastTransactionPrice, midMarketPrice)}`}>
              {getVariationIcon(olswapData.lastTransactionPrice, midMarketPrice)}
              {Math.abs((olswapData.lastTransactionPrice / midMarketPrice - 1) * 100).toFixed(2)}%
            </td>
          </tr>
          <tr>
            <td className="py-2 px-4">Osmosis LTP</td>
            <td className="py-2 px-4">${osmosisPoolData.price.toFixed(6)}</td>
            <td className={`py-2 px-4 ${getStyle(osmosisPoolData.price, midMarketPrice)}`}>
              {getVariationIcon(osmosisPoolData.price, midMarketPrice)}
              {Math.abs((osmosisPoolData.price / midMarketPrice - 1) * 100).toFixed(2)}%
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  );
}

export default MMPVariationsTable;
